import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState';

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const transportadoraReducer = (state = InitialState.transportadoraReducer, action) => {
    switch (action.type) {
        case ActionType.GET_TRANSPORTADORA_RESPONSE: {
            return {
                ...state,
                transportadoraObject: _.assign(action.transportadoraObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default transportadoraReducer;